class BMDesktopMenu extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.items = [...this.querySelectorAll('.bm-desktop-nav__item')];
    this.backdrop = document.createElement('div');
    this.backdrop.className = 'bm-desktop-nav__backdrop';
    this.backdrop.hidden = true;
    document.body.append(this.backdrop);
    for (const item of this.items) {
      item.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        clearTimeout(this.timer);
        this.open(item);
      }, options);
      item.addEventListener('pointerleave', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!item.contains(document.activeElement)) this.close();
        }, 170);
      }, options);
      item.addEventListener('focusin', () => {
        if (!this.restoringFocus) this.open(item);
      }, options);
      item.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }, options);
    }
    this.backdrop.addEventListener('pointerenter', () => this.close(), options);
    this.backdrop.addEventListener('click', () => this.close(), options);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.active) {
        const trigger = this.active.querySelector('.bm-desktop-nav__trigger');
        this.close();
        this.restoringFocus = true;
        trigger.focus();
        this.restoringFocus = false;
      }
    }, options);
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.close();
    }, options);
    window.addEventListener('resize', () => this.close(), options);
    window.addEventListener('scroll', () => this.close(), { ...options, passive: true });
  }
  open(item) {
    clearTimeout(this.timer);
    if (this.active === item) return;
    this.close();
    const panel = item.querySelector('.bm-desktop-nav__panel');
    if (!panel || !matchMedia('(min-width:750px)').matches) return;
    this.active = item;
    panel.hidden = false;
    item.querySelector('.bm-desktop-nav__trigger').setAttribute('aria-expanded', 'true');
    document.body.classList.add('bm-desktop-menu-open');
    const header = this.closest('header-component');
    this.backdrop.style.setProperty('--bm-menu-header-bottom', (header?.getBoundingClientRect().bottom || 100) + 'px');
    this.backdrop.hidden = false;
    const rect = panel.getBoundingClientRect();
    panel.style.setProperty("--bm-menu-available-height", Math.max(160, innerHeight - rect.top - 58) + "px");
    if (rect.right > innerWidth - 16) panel.style.left = (innerWidth - 16 - rect.right - 18) + 'px';
  }
  close() {
    clearTimeout(this.timer);
    if (this.active) {
      this.active.querySelector('.bm-desktop-nav__panel').hidden = true;
      this.active.querySelector('.bm-desktop-nav__panel').style.left = '';
      this.active.querySelector('.bm-desktop-nav__trigger').setAttribute('aria-expanded', 'false');
      this.active = null;
    }
    document.body.classList.remove('bm-desktop-menu-open');
    if (this.backdrop) this.backdrop.hidden = true;
  }
  disconnectedCallback() {
    this.close();
    this.abort?.abort();
    this.backdrop?.remove();
  }
}
if (!customElements.get('bm-desktop-menu')) customElements.define('bm-desktop-menu', BMDesktopMenu);
